import React from "react";
import { Tag } from "antd";

// Map status sản phẩm -> nhãn màu. status: available | out_of_stock | error | unknown
const STATUS_META = {
    available: { color: "green", label: "Còn hàng" },
    out_of_stock: { color: "orange", label: "Hết hàng" },
    error: { color: "red", label: "Lỗi / đã gỡ" },
    unknown: { color: "default", label: "Chưa kiểm tra" },
};

function StockStatusTag({ status }) {
    const meta = STATUS_META[status] || STATUS_META.unknown;
    return <Tag color={meta.color}>{meta.label}</Tag>;
}

export default StockStatusTag;
